import SelectField from "../common/SelectField";
import SearchBar from "../common/SearchBar";
import "../../styles/common.css";
import "../../styles/driverHeader.css";

import { Plus,Users, Wallet } from "lucide-react";

export default function ClientHeader({ 
  total, search, onSearch, balanceFilter, onBalanceChange
}) {
  return (
    <div className="pageHeader">
      <div className="headerTop">
        <div className="pageTitle">
          <div className="titleWithIcon">
            <Users size={24} className="primaryIcon" />
            <h2>Gestion des Clients</h2>
          </div>
          <span className="countBadge">{total} clients</span>
        </div>
      </div>

      <div className="filterActionsRow">
        <div className="selectorsGrid">
          <SelectField
            icon={Wallet}
            value={balanceFilter}
            onChange={onBalanceChange}
            options={[
              { label: "Tous les soldes", value: "all" },
              { label: "Solde positif", value: "positive" },
              { label: "Solde nul / négatif", value: "zero" },
            ]}
          />
        </div>

        <div className="searchWrapper">
          <SearchBar
            value={search}
            onChange={onSearch}
            placeholder="Rechercher client, téléphone..."
          />
        </div>
      </div>
    </div>
  );
}